import React, { Fragment, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { Below } from '@jetshop/ui/Breakpoints';
import { DrawerTarget } from '@jetshop/ui/Modal/Drawer';
import DataProvider from './Categories/CategoryProvider';
import TopBar from './TopBar/TopBar';
import DesktopHeader from './Desktop/DesktopHeader';
import DesktopNav from './Desktop/DesktopNav';
import MobileHeader from './Mobile/MobileHeader';
import MobileNav from './Mobile/MobileNav';
import CartFlyout from '../../Cart/CartFlyout';
import { theme } from '../../Theming/Theming';
import { useLocation } from 'react-router';

const HeaderWrapper = styled('header')`
  position: sticky;
  top: 0;
  z-index: 104 !important;
  width: 100%;
  a {
    text-decoration: none;
  }
`;

const Header = ({ categoryTreeRoots, categories }) => {
  const [searchOpen, setSearch] = useState(false);
  const [scrolling, setScroll] = useState(false);
  const location = useLocation();
  const isStart = location.pathname === '/';

  const handleScroll = (event) => {
    if (typeof window === 'undefined') return false;

    if (window.scrollY > theme.header.scrollBreak && !scrolling) {
      setScroll(true);
    } else if (window.scrollY === 0 && scrolling) {
      setScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <>
      <Below breakpoint="lg">
        {(matches) =>
          matches ? (
            <Fragment>
              <HeaderWrapper id="main-header">
                <TopBar scrolling={scrolling} />
                <MobileHeader
                  searchOpen={searchOpen}
                  setSearch={setSearch}
                  scrolling={scrolling}
                  isStart={isStart}
                />{' '}
              </HeaderWrapper>
              <DrawerTarget id="menuDrawer" showCover={true}>
                {({ isOpen, hideTarget }) => (
                  <MobileNav
                    categories={categories}
                    categoryTreeRoots={categoryTreeRoots}
                    onClick={hideTarget}
                    isOpen={isOpen}
                    hideTarget={hideTarget}
                  />
                )}
              </DrawerTarget>
            </Fragment>
          ) : (
            <HeaderWrapper id="main-header">
              <TopBar scrolling={scrolling} />
              <DesktopHeader
                scrolling={scrolling}
                searchOpen={searchOpen}
                setSearch={setSearch}
                isStart={isStart}
              >
                <DesktopNav
                  scrolling={scrolling}
                  categoryTreeRoots={categoryTreeRoots}
                />
              </DesktopHeader>
            </HeaderWrapper>
          )
        }
      </Below>
      <CartFlyout />
    </>
  );
};

const HeaderComponent = () => (
  <DataProvider>{(props) => <Header {...props} />}</DataProvider>
);

export default HeaderComponent;
